import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet-async';

const GroupRoadTrip = () => {
    return (
        <>
            <Helmet>
                <title>The Ultimate Guide to Group Road Trips with a Van Rental</title>
                <meta
                    name="description"
                    content="Plan the perfect group road trip with this complete van rental guide. Learn tips for choosing vans, planning routes, and traveling together."
                />
            </Helmet>
            <div className="bg-[#fff] w-full flex flex-col">
                <section
                    className="hero--container relative flex flex-col justify-center w-ful bg-no-repeat bg-cover bg-center pt-[65px] mt-[140px] md:h-[60vh]"
                    style={{ backgroundImage: `url('../images/group-road-trip.jpg')` }}
                >
                    <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
                    <div className="relative z-10">
                        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
                            The Ultimate Guide to Group Road Trips with a Van Rental
                        </h1>

                        <div className="flex justify-center items-center gap-4 mt-10 md:text-sm text-xs mb-2">
                            <div className="flex items-center gap-2 text-white">
                                <FontAwesomeIcon icon={faClock} className="w-4" />
                                <p className="blog-publish-date">01/04/2026</p>
                            </div>

                            <div className="flex items-center gap-2 text-white">
                                <FontAwesomeIcon icon={faComment} className="w-4" />
                                <p className="blog-publish-date">12 Comments</p>
                            </div>

                            <div className="flex items-center gap-2 text-white">
                                <FontAwesomeIcon icon={faBookmark} />
                                <p className="blog-publish-date">1840 Views</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
                    <div className="mx-auto max-w-screen-md">
                        <p className="pb-4 text-justify leading-7">
                            Planning a group road trip is exciting—but organizing transportation for everyone can be a challenge. That’s where renting a van makes all the difference. Whether it’s a friends’ getaway, family vacation, or corporate retreat, a rental van offers space, flexibility, and comfort for the entire group.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            One of the biggest advantages of renting a van is **convenience**. Instead of traveling in multiple vehicles, your entire group can stay together. This not only reduces fuel costs but also makes coordination easier. Everyone arrives together and no one gets lost.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            When choosing a van rental, consider the size of your group and the type of trip you’re planning. Passenger vans are great for groups of 8 to 15 people, while cargo vans can carry luggage or gear for outdoor adventures. Make sure to book in advance, especially during peak travel seasons.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            Many van rental companies, like JJ Van Rental, also offer **doorstep delivery** to your home, office, or airport—saving you time and hassle on pickup day. Just be sure to confirm the delivery time and check all required documents ahead of your trip.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            Don’t forget to plan your route and schedule breaks. Long drives can be tiring, and group travel means accommodating different needs. Apps like Google Maps or Roadtrippers can help you map out fuel stops, restaurants, and sightseeing spots along the way.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            In conclusion, renting a van for your group road trip ensures a smoother, more enjoyable journey for everyone involved. From shared playlists to spontaneous photo stops, the shared experience of traveling together creates lasting memories. Make sure to plan smart, pack light, and enjoy the ride.
                        </p>
                    </div>
                </section>

                <section className="mb-8">
                    <div className="max-w-screen-md mx-auto px-4 py-3 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                        {/* Tags Section */}
                        <div className="flex flex-wrap gap-2">
                            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Van Rental</p>
                            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Group Travel</p>
                            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Road Trip Tips</p>
                        </div>

                        {/* Social Buttons Section */}
                        <div className="flex flex-wrap items-center gap-3">
                            <div className="flex items-center bg-[#42599E] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faFacebook} /> Share
                                </a>
                            </div>
                            <div className="flex items-center bg-[#55ACEE] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faTwitter} /> Tweet
                                </a>
                            </div>
                            <div className="flex items-center bg-[#34AF23] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
                                </a>
                            </div>
                            <div className="flex items-center bg-[#0798CF] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
                                </a>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </>
    );
};

export default GroupRoadTrip;